import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAdminAuth } from "./lib/auth";
import { AdminLayout } from "./components/layout";
import { AuthPage } from "./pages/auth-page";
import { AccountsPage } from "./pages/accounts-page";
import { AccountPage } from "./pages/account-page";
import { FunnelPage } from "./pages/funnel-page";
import { RunPage } from "./pages/run-page";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 15_000,
    },
  },
});

function ProtectedApp() {
  const { token, isReady } = useAdminAuth();

  if (!isReady) {
    return (
      <div className="admin-shell flex min-h-screen items-center justify-center p-4 text-sm text-muted-foreground">
        Проверяем админ-сессию...
      </div>
    );
  }

  if (!token) {
    return (
      <Routes>
        <Route path="/login" element={<AuthPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/accounts" replace />} />
      <Route element={<AdminLayout />}>
        <Route path="/" element={<Navigate to="/accounts" replace />} />
        <Route path="/accounts" element={<AccountsPage />} />
        <Route path="/accounts/:id" element={<AccountPage />} />
        <Route path="/funnels/:id" element={<FunnelPage />} />
        <Route path="/runs/:id" element={<RunPage />} />
        <Route path="/funnels" element={<Navigate to="/accounts" replace />} />
        <Route path="/runs" element={<Navigate to="/accounts" replace />} />
        <Route path="*" element={<Navigate to="/accounts" replace />} />
      </Route>
    </Routes>
  );
}

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ProtectedApp />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
